module.exports = __webpack_public_path__ + "static/img/8.338138b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/8.png
// module id = IUss
// module chunks = 1